import { render, staticRenderFns } from "./TelegramPartners.vue?vue&type=template&id=9cedb96c&"
import script from "./TelegramPartners.vue?vue&type=script&lang=js&"
export * from "./TelegramPartners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports